<template>
    <div id="main">
      <div class="width-auto container">
        <el-carousel height="600px" class="hidden-xs hidden-sm img-pos">
          <el-carousel-item v-for="item in bannerList" :key="item.id">
              <img :src="item.src" alt="">
<!--            <div class="advert">-->
<!--              <h2 class="advert-title">智能巡检机器人</h2>-->
<!--              <p class="sub-title">YNEN-9X L3</p>-->
<!--              <div class="advert-info">-->
<!--                一款专为配电开关室运维设计的智能产品。它基于边缘计算框架设计，能根据配电开关室的运 维要求，实现数据采集、分析的自动化，独立完成配电开关室的全部运维巡检任务。-->
<!--              </div>-->
<!--            </div>-->
          </el-carousel-item>
        </el-carousel>
      </div>
      <van-swipe :autoplay="3000" indicator-color="white" class=" visible-sm img-pos">
        <van-swipe-item v-for="item in bannerListMob" :key="item.id">
          <img :src="item.src" alt="">
        </van-swipe-item>
      </van-swipe>
      <van-swipe :autoplay="3000" indicator-color="white" class="visible-xs  img-pos">
        <van-swipe-item v-for="item in bannerListMobs" :key="item.id">
          <img :src="item.src" alt="">
        </van-swipe-item>
      </van-swipe>
      <div class='react-info visible-xs '>
        <van-panel title="技术服务" >
          <div class="info-content">
              <van-cell v-for="item in serverList" :title="item.name" :key="item.id" @click="jumpServer(item.id)" />
<!--            <ul class="news-list">-->
<!--              <li class="news-item" v-for="item in serverList" :key="item.id" @click="jumpServer(item.id)">-->
<!--                {{item.name}}-->
<!--              </li>-->
<!--            </ul>-->
          </div>
        </van-panel>
        <van-panel title="新闻中心" >
          <div class="info-content">
            <van-cell v-for="item in newsList" :title="item.name" :key="item.id" @click="jumpServer(item.id)" />
          </div>
        </van-panel>
      </div>
      <div class="inform hidden-xs">
        <div class="container" >
          <div class="cate-title">
            <h2>产品展示</h2>
          </div>
          <div class="row-scroll-product">
<!--            <el-button class="el-icon-arrow-left"  @click="zuohua"></el-button>-->
              <ul  :style="{'left':calleft + 'px', width: widthData + 'px'} " v-on:mouseover="stopmove()" v-on:mouseout="move()" class="imgBoxoul">
                <li class="DataList_top"   @click="detailJump(item.id)" v-for="(item,index) in goodsList[0].child" :key="item.id" >
                  <img :src="item.path" alt="" class="product-img">
                  <p class="product-name">{{item.name}}</p>
                  <p class="product-model">{{item.model}}</p>
                </li>
              </ul>
<!--            <el-button class="el-icon-arrow-right"  @click="youhua"></el-button>-->
          </div>
          <div style="clear: both"></div>
          <div class="cate-title">
            <h2>新闻中心</h2>
          </div>
          <div class="news">
            <div class="news-headlines" v-for="(item,index) in newsList" v-if="index<2" :key="item.id">
              <img :src="item.src" class="news-img" alt="">
              <div class="news-box">
                <p class="news-title" @click="jumpNews(item.id)" v-html="item.name"></p>
                <p class="news-time">时间：{{item.data}}</p>
                <div class="news-intro" v-html="item.intro"></div>
              </div>
            </div>
            <div class="news-list">
              <ul>
                <li class="news-item" v-for="item in newsList" @click="jumpNews(item.id)">
                  <p class="news-name" v-html="item.name"></p>
                  <p class="news-time">时间：{{item.data}}</p>
                </li>
              </ul>
            </div>
          </div>
          <div class="cate-title">
            <h2>技术动态</h2>
          </div>
          <div class="dynamic">
            <el-carousel :interval="5000" arrow="never"  height="500px" :autoplay="false" ref="carousel">
              <el-carousel-item v-for="item in serverList" :key="item.id">
                <div class="dynamic-left">
                  <img :src="item.img" alt="">
                </div>
                <div class="dynamic-right">
                  <p class="dynamic-title">{{item.name}}</p>
                  <p class="dynamic-time">{{item.data}}</p>
                  <div class="dynamic-con" v-html="item.intro"></div>
                  <el-button class="read-more" @click="jumpServer(item.id)">阅读全文</el-button>
                </div>
              </el-carousel-item>
            </el-carousel>
            <div class="arrow">
              <span class="el-icon-arrow-left" @click="prev"></span>
              <span class="el-icon-arrow-right" @click="next"></span>
            </div>
          </div>
        </div>

      </div>
    </div>
</template>

<script>

  import News from '../../assets/data/news.js';
  import Server from '../../assets/data/server.js';
  import Daily from '../../assets/data/goods-list.js';

  export default {
        name: "Main",
    data(){
      return{
        calleft: 0,
        active:false,
        newsList:[],
        goodList:[
          {
            'id': 'a-1',
            'name': '轮式巡检机器人',
          }, {
            'id': 'a-2',
            'name': '轨道巡检机器人',
          }
        ],
        goodsList:[],
        bannerList:[
          {
            "id":1,
            "src":"./static/images/sy.png"
          },
        ],
        bannerListMob:[
          {
            "id":1,
            "src":"./static/images/sy.png"
          },
        ],
        bannerListMobs:[
          {
            "id":1,
            "src":"./static/images/sy.png"
          },
        ],
        serverList:[],
      }
    },
    computed: {
      widthData(){
        return 356 * Number(this.goodsList.length+1)*2
      }
    },
    mounted() {
      var imgBox = document.getElementsByClassName("imgBoxoul")[0];
      imgBox.innerHTML += imgBox.innerHTML;
    },
    created() {
      this.goodsList = Daily.goods;
      this.newsList = News.news;
      this.serverList = Server.server;
      this.active = true;
      // this.move()
    },

    methods:{
      detailJump(path){
        debugger
        this.$router.push({
          name: 'product-detail',
          params:{
            id:path
          }
        })
      },
          //轮播手动切换
      prev(){
        this.$refs.carousel.prev()
      },
      next(){
        this.$refs.carousel.next()
      },
          //产品滑动
      //移动
      move() {
        this.timer = setInterval(this.starmove, 20);
      },
      //开始移动
      starmove() {
        this.calleft -= 1.2;//*this.speed
        if (this.calleft <= -745) {
          this.calleft = 0;
        }
      },
      //鼠标悬停时停止移动
      stopmove() {
        clearInterval(this.timer);
      },
      //点击按钮左移
      zuohua() {
        this.calleft -= 356;//this.speed = 1
        if (this.calleft <= -745) {
          this.calleft = 0;
        }
      },
      //点击按钮右移
      youhua() { //this.speed = -1
        this.calleft += 356;
        if (this.calleft >= 0) {
          this.calleft = -745;
        }
      },
      jumpNews(id){
        this.$router.push({
          name: 'news-detail',
          params:{
            id:id
          }
        })
      },
      jumpGoods(id){
        this.$router.push({
          name: 'product-detail',
          params:{
            id:id
          }
        })
      },
      jumpServer(id){
        this.$router.push({
          name: 'server-detail',
          params:{
            id:id
          }
        })
      },
    }
    }
</script>

<style scoped lang="less">
  @media (min-width: 1400px){
    .container {
      width: 1400px;
    }
  }
  @media (min-width: 1200px){
    .container {
      width: 1400px;
    }
  }
  @media (min-width: 992px){
    .container {
      width: 1400px;
    }
  }
#main{
  .container{
    padding: 0;
    .advert{
      padding: 54px 54px 54px 72px;
      background-color: rgba(#E96B2E,0.9);
      position: absolute;
      left: 0;
      top: 94px;
      color:#ffffff;
      .advert-title{
        font-size: 38px;
        line-height: 38px;
        font-weight: bold;
        color:#ffffff;
        text-align: left;
      }
      .sub-title{
        letter-spacing: 1px;
        font-size: 18px;
        margin-bottom: 44px;
      }
      .advert-info{
        font-size: 16px;
        letter-spacing: 1px;
        width: 400px;
      }
    }
  }
  .van-cell .van-cell__title{
    font-weight: normal;
  }
  .van-panel__header .van-cell__title{
    font-weight: bold;
  }
  .el-carousel__container{
    height: 600px;
    .el-carousel-item{
      position: relative;
      img{
        width: 100%;
      }

    }
  }
  .img-pos{
    img{
      width: 100%;
    }
  }
  .react-info{
    .van-panel{
      .van-cell__value{
        font-weight: bold;
        font-size: 16px;
      }
    }
  }
  .inform{
    margin-bottom: 80px;
    .container{
      display: flex;
      flex-direction: column;
      .cate-title{
        padding: 52px 0 20px;
        h2{
          font-size: 28px;
          line-height: 28px;
          font-weight: bold;
          text-align: left;
          margin:0;
        }
      }
      .row-scroll-product{
        position: relative;
        overflow: hidden;
        height: 321px;
        .imgBoxoul{
          margin: 0 auto;
          width: 2800px;
          position: absolute;
          left: 0;
          cursor: pointer;
          z-index: 10;
          .DataList_top{
            float: left;
            width: 334px;
            margin-right: 22px;
            .product-img{
              width: 100%;
              height: 252px;
              margin-bottom: 14px;
            }
            .product-name{
              font-size: 18px;
              line-height: 18px;
              margin-bottom: 13px;
              font-weight: bold;
            }
            .product-model{
              font-size: 14px;
              line-height: 14px;
            }
          }
        }
        .el-icon-arrow-left,.el-icon-arrow-right{
          position: absolute;
          top: 126px;
          font-size: 20px;
          color:#999;
          display: block;
          width: 40px;
          height: 72px;
          text-align: center;
          line-height: 72px;
          z-index: 100;
          padding: 0;
          opacity: 0;
        }
        .el-icon-arrow-right{
          right: 0;
        }
        &:hover{
          .el-icon-arrow-left,.el-icon-arrow-right{
            opacity: 1;
          }
        }
      }
      .news{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .news-headlines{
          width: 446px;
          height: 514px;
          background-color: #f5f5f5;
          margin-right: 30px;
          &:last-child{
            margin-right: 0;
          }
          .news-img{
            width: 100%;
            height: 278px;
          }
          .news-box{
            padding: 30px;
            .news-title{
              cursor: pointer;
              font-size: 18px;
              font-weight: bold;
              margin-bottom: 20px;
              line-height: 18px;
            }
            .news-time{
              font-size: 14px;
              line-height: 14px;
              color:#666666;
              margin-bottom: 30px;
            }
            .news-intro{
              line-height: 28px;
              font-size: 15px;
              overflow : hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 4;
              -webkit-box-orient: vertical;
            }
          }
        }
        .news-list{
          width: 448px;
          height: 514px;
          background-color: #f5f5f5;
          overflow-y: scroll;
          &::-webkit-scrollbar {/*滚动条整体样式*/
            width: 4px;     /*高宽分别对应横竖滚动条的尺寸*/
            height: 4px;
          }
          &::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
            border-radius: 5px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.2);
          }
          &::-webkit-scrollbar-track {/*滚动条里面轨道*/
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            border-radius: 0;
            background: rgba(0,0,0,0.1);
          }
          .news-item{
            padding: 14px 28px;
            width: 100%;
            cursor: pointer;
            .news-name{
              font-size: 18px;
              margin-bottom: 10px;
              line-height: 28px;
              font-weight: bold;
            }
            .news-time{
              font-size: 14px;
              line-height: 14px;
              color: #666666;
            }
            &:hover{
              background-color: #fff;
              box-shadow: inset 0px 0px 20px rgba(0,0,0,0.2);
            }
          }
        }
      }
      .dynamic{
        position: relative;
        .el-carousel__item{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .dynamic-left,.dynamic-right{
            width: 50%;
          }
          .dynamic-left{
            img{
              width: 100%;
              height: 500px;
            }
          }
          .dynamic-right{
            background-color: #f5f5f5;
            padding: 35px 55px;
            .dynamic-title{
              font-size: 30px;
              font-weight: bold;
              line-height: 30px;
              margin-bottom: 18px;
            }
            .dynamic-time{
              font-size: 15px;
              color:#666666;
              margin-bottom: 28px;
            }
            .dynamic-con{
              width: 100%;
              height: 220px;
              font-size: 15px;
              line-height: 28px;
              overflow : hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 8;
              -webkit-box-orient: vertical;
              margin-bottom: 40px;
            }
            .read-more{
              width: 146px;
              height: 46px;
            }
          }
        }
        .arrow{
          position: absolute;
          bottom: 0;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          width: 100px;
          height: 50px;
          left: 650px;
          z-index: 99;
          .el-icon-arrow-left,.el-icon-arrow-right{
            width: 50px;
            height: 50px;
            line-height: 50px;
            text-align: center;
            font-size: 25px;
            display: block;
          }
          .el-icon-arrow-left{
            color:#ffffff;
            background-color: #243AA9;
          }
          .el-icon-arrow-right{
            color:#243AA9;
            background-color: #fff;
          }
        }
      }
    }
    .restore{
      transform: translateY(0);
      opacity: 1;
    }

  }
}
</style>

<style lang="less">
  .el-breadcrumb{
    vertical-align: bottom;
    display: inline-block;
    .el-breadcrumb__item{
      &:last-child{
        .el-breadcrumb__inner{
          color: #999999!important;
          font-size: 12px;
        }
      }

      .el-breadcrumb__inner.is-link{
        color: #999999;
        font-size: 12px;
      }
    }

  }
  .react-info{
    .van-panel{
      .van-cell{
        .van-cell__title{
          font-weight: bold;
          font-size: 16px;
        }
      }

    }
    .van-hairline--top-bottom::after, .van-hairline-unset--top-bottom::after{
      border: none;
    }
  }
  @media screen and (max-width: 1000px) {
    #main .inform .container::after,#main .inform .container::before{
      content:none!important;
      display: none;
    }
    #main .inform .container .inform-style .all-msg .headline{
      width: 150px!important;
      height: 108px!important;
    }
    #main .inform .container .inform-style .article-box{
      width: calc(100% - 170px) !important
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/page/main.vue